import { AbstractAddValueToArrayCommand } from "./AbstractAddValueToArrayCommand";

export class AddValueToArrayCommand<TSource, TValue> extends AbstractAddValueToArrayCommand<TSource, TValue> {
  constructor(private readonly _readArray: (s: TSource) => TValue[], value: TValue, index?: number) {
    super(value, index);
  }

  protected readArray(source: TSource): TValue[] {
    return this._readArray(source);
  }
}
